import { makeStyles } from "@mui/styles";
import { COLORS } from "../../Theme/colors.js";

const FooterStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: COLORS.BLACK,
    minHeight: "235px",
    padding: "35px 60px",
    position: "relative",
    zIndex: 0,
    "& a": {
      color: "inherit"
    }
  },
  narrowContainer: {
    padding: "35px 20px"
  },
  contactUs: {
    marginBottom: "10px"
  },
  emailLink: {
    marginTop: "10px",
    "& svg": {
      color: COLORS.WHITE,
      fontSize: "24px",
      marginRight: "10px"
    }
  },
  bigStuff: {
    borderBottom: `1px solid ${COLORS.GRAY}`,
    height: "120px"
  },
  spaced: {
    marginTop: "15px"
  }
}));

export default FooterStyles;
